// extracted by mini-css-extract-plugin
export default {"container":"SelfieCam_container__4VIUk","video":"SelfieCam_video__YFGGZ"};